export const MAX_MEDIA_VIEWER_TITLE_LENGTH = 50;

/** Truncate toolbar filenames; full value should be shown in a tooltip. */
export function truncateDisplayTitle(
  title: string,
  maxLength = MAX_MEDIA_VIEWER_TITLE_LENGTH
): string {
  const trimmed = title.trim();
  if (trimmed.length <= maxLength) return trimmed;
  if (maxLength <= 3) return '.'.repeat(maxLength);
  return `${trimmed.slice(0, maxLength - 3)}...`;
}
